import { useMediaQuery } from 'react-responsive';
import img from '../assetes/icons/unauthorized.png'
import { tabletQuery } from '../utils/helper';

const Unauthorized = () => {
  const isTablet = useMediaQuery(tabletQuery)

  return (
    <div className='flex flex-col justify-center items-center p-[4rem]'>
      <img
        src={img}
        className='w-[200px] h-[auto]'
        alt="unauthorized"
      />
      <div className='text-blue-900 tracking-wider' style={{
        fontSize: isTablet ? '1rem' : '2.5vw',
        fontWeight: 'bolder'
      }}>
        Sorry, it seems that you dont have enough permissions to view this page..
      </div>
    </div>
  );
}
 
export default Unauthorized;